import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-pagetitle',
  templateUrl: './pagetitle.component.html',
  styleUrls: ['./pagetitle.component.scss']
})
export class PagetitleComponent implements OnInit {

  @Input() breadcrumbItems: any;
  @Input() title: string | undefined;
  @Input() subtitle?: string;
  @Input() actionButton?: {
    label: string;
    onClick: () => void;
  };


  constructor() { }

  ngOnInit(): void {
  }

}
